<template>
    <v-data-table
        :headers="journeyTable.headers"
        :items="journeys"
        hide-actions
    >
        <template v-slot:items="props">
            <journey-table-row :item="props" @redirect-journey="redirectToJourney" :is-active="isJourneyActive(props)"></journey-table-row>

        </template>
    </v-data-table>
</template>

<script>
import JourneyTableRow from './Timeline/JourneyTableRow'

export default {
    name: 'JourneysTable',
    components: {
        JourneyTableRow
    },
    data () {
        return {
            journeyTable: {
                headers: [
                    {
                        text: 'Start',
                        align: 'center',
                        sortable: false,
                        width: '15%'
                    },
                    {
                        text: 'Stop',
                        align: 'center',
                        sortable: false,
                        width: '15%'
                    },
                    {
                        text: 'Start location',
                        align: 'center',
                        sortable: false,
                        width: '30%'
                    },
                    {
                        text: 'Stop location',
                        align: 'center',
                        sortable: false,
                        width: '30%'
                    },
                    {
                        text: 'Milage',
                        align: 'center',
                        sortable: false,
                        width: '10%'
                    }
                ]
            }
        }
    },
    props: {
        journeys: {
            required: false,
            default: () => []
        },
        isJourney: {
            type: Boolean,
            required: false,
            default: false
        },
        currentJourney: {
            type: [String, null],
            required: false,
            default: null
        }
    },
    methods: {
        redirectToJourney (journey) {
            this.$emit('redirect-journey', journey)
        },
        isJourneyActive (journey) {
            return journey.item.id === this.currentJourney
        }
    }
}
</script>

<style scoped>

</style>
